export default __webpack_public_path__ + "static/media/023 - X.001c18d6.svg";